import React, { FC } from 'react';
import {
  Create,
  CreateProps,
  FormTab,
  TabbedForm,
  useNotify,
  useRefresh,
} from 'react-admin';
import { makeUpWinnersRequest } from '../../helpers/winnerRequest';
import dataProvider from '../../providers/dataProvider';
import { WinnerCreateData } from '../../types/winnerRequest';
import DocumentTitleSettings from '../common/documentTitle/DocumentTitleSettings';
import StaffUserFormToolbar from '../staff/StaffUserFormToolBar';
// import DescriptionTabForm from "./DescriptionTabForm";
import './index.css';

const CreateWidget: FC<CreateProps> = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const onSuccess = () => async (data) => {
    const winnerData: WinnerCreateData = {
      drawDate: data.drawDate,
      title: data.name,
      ...data,
    };
    const multipartData = makeUpWinnersRequest(winnerData);
    const result = await dataProvider.createWidget('winners', {
      data: multipartData,
    });
    if (!result.data) {
      notify('something went wrong', 'error');
    }
    notify(`Winner saved`);
    refresh();
  };

  const validateWinner = (value) => {
    const errors: any = {};
    if (!value.name) {
      errors.title = ['Title is required'];
    }
    if (!value.photoUrl && !value.videoUrl) {
      errors.photoUrl = [
        'Please choose photo or upload a photo. At least something should be chosen',
      ];
      errors.videoUrl = [
        'Please choose video url or upload a photo. At least something should be chosen',
      ];
    }
    return errors;
  };
  return (
    <>
      <DocumentTitleSettings core='Winners' purpose='Add new widget' />
      <Create {...props}>
        <TabbedForm
          toolbar={<StaffUserFormToolbar onSuccess={onSuccess()} {...props} />}
          //   validate={validateWinner}
        >
          <FormTab label='Main'>
            {/* <DescriptionTabForm {...props}/> */}
          </FormTab>
        </TabbedForm>
      </Create>
    </>
  );
};

export default CreateWidget;
